var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.classes, on: { click: _vm.toggleEditMode } }, [
    !_vm.editMode
      ? _c(
          "div",
          [
            _vm.loading
              ? _c("CompassSkeleton", { attrs: { size: "x-large" } })
              : _c(
                  "div",
                  { staticClass: "edit-single-user__content" },
                  [
                    _c("CompassAvatar", {
                      attrs: {
                        initials: _vm.userInitials,
                        size: "small",
                        colorType: _vm.randAvatarColorFullname(_vm.data.name),
                        stateBadge: _vm.stateBadge,
                        photo: _vm.userPhoto
                      }
                    }),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.data.name))])
                  ],
                  1
                )
          ],
          1
        )
      : _c(
          "div",
          [
            _c(
              "CompassSelect",
              {
                attrs: { filterable: "", forceSelectOpen: "" },
                on: {
                  "update:value": _vm.handleValueUpdate,
                  close: function($event) {
                    _vm.editMode = false
                  }
                },
                model: {
                  value: _vm.selectedUser,
                  callback: function($$v) {
                    _vm.selectedUser = $$v
                  },
                  expression: "selectedUser"
                }
              },
              _vm._l(_vm.filteredStaff, function(item) {
                return _c("CompassDropdownSelectOption", {
                  key: item.id,
                  attrs: {
                    label: item.firstname + " (" + item.lastname + ")",
                    value: item.id,
                    type: "avatar",
                    avatar: {
                      photo: item.avatar,
                      initials: _vm.getInitials(item.firstname, item.lastname),
                      state: "default",
                      colorType: _vm.randAvatarColorFullname(
                        item.firstname + " " + item.lastname
                      )
                    }
                  }
                })
              }),
              1
            )
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }